export default __webpack_public_path__ + "static/media/Girdle of Brutal Carnage.f7d57bd5.jpg";